import { z } from "zod";
export const DTODocumentationConfiguration = z.object({
    tabbed: z.boolean(),
    isPublic: z.boolean(),
    selectedBrandId: z.string().nullish(),
    storybookEmbedErrorMessage: z.string().nullish(),
    renderCodePackageJson: z.string().nullish(),
});
export const DTODocumentationConfigurationResponse = z.object({
    documentation: z.object({
        designSystemId: z.string(),
        designSystemVersionId: z.string(),
        settings: DTODocumentationConfiguration,
    }),
});
